<template>
  <v-card class="mb-4">
    <v-card-title class="d-flex align-center">
      <v-icon class="mr-2" color="info">mdi-account-group</v-icon>
      {{ t.dashboard?.client_search || 'Client Search' }}
    </v-card-title>
    <v-card-text>
      <v-row align="start">
        <v-col cols="12" md="6">
          <ClientSearchFilter
            v-model="selectedClientId"
            v-model:include-subclients="includeSubclients"
            :show-include-subclients="true"
            :client-select-label="t.dashboard?.select_client || 'Select Client'"
            @hierarchy-loaded="onHierarchyLoaded"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="searchTerm"
            :label="t.dashboard?.client_search_label || 'Search by name, email, phone'"
            :hint="t.dashboard?.minimum_2_chars || 'Minimum 2 characters'"
            persistent-hint
            prepend-inner-icon="mdi-magnify"
            clearable
            density="compact"
            variant="outlined"
            hide-details
            @keyup.enter="search"
            @click="$event.target.select()"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-btn color="primary" block @click="search" :disabled="!canSearch">
            <v-icon class="mr-1">mdi-magnify</v-icon>
            {{ t.common?.search || 'Search' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'
import ClientSearchFilter from '@/components/ClientSearchFilter.vue'

export default {
  name: 'ClientSearchSection',
  components: { ClientSearchFilter },
  props: {
    config: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      searchTerm: '',
      selectedClientId: null,
      includeSubclients: true,
      hasSubclients: false
    }
  },
  computed: {
    t() { return tRef.value },
    canSearch() {
      return (this.searchTerm?.trim().length >= 2) || this.selectedClientId
    }
  },
  methods: {
    onHierarchyLoaded({ hasSubclients }) {
      this.hasSubclients = hasSubclients
    },
    search() {
      if (!this.canSearch) return

      const query = {}

      if (this.searchTerm?.trim().length >= 2) {
        query.search = this.searchTerm.trim()
      }
      if (this.selectedClientId) {
        query.client_id = this.selectedClientId
      }
      if (this.includeSubclients) {
        query.include_subclients = 'true'
      }

      this.$router.push({ path: '/clients', query })
    }
  }
}
</script>
